import { DarkMode, KeyboardArrowDown, LightMode } from '@mui/icons-material';
import {
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import React, { useState } from 'react';
import { useThemeMode } from '../../theme/studioThemeProvider';

export const ThemeToggle: React.FC = () => {
  const { mode, toggleMode } = useThemeMode();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModeSelect = (selectedMode: 'light' | 'dark') => {
    if (selectedMode !== mode) {
      toggleMode();
    }
    handleClose();
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        startIcon={mode === 'dark' ? <DarkMode /> : <LightMode />}
        endIcon={<KeyboardArrowDown />}
        sx={{
          color: 'text.primary',
          textTransform: 'none',
          fontWeight: 400,
          fontSize: '14px',
          padding: '6px 12px',
          borderRadius: '6px',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {mode === 'dark' ? 'Dark mode' : 'Light mode'}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 140,
            borderRadius: '8px',
            border: (theme) => `1px solid ${theme.palette.divider}`,
          },
        }}
      >
        <MenuItem
          onClick={() => handleModeSelect('light')}
          selected={mode === 'light'}
          sx={{ fontSize: '14px' }}
        >
          <ListItemIcon sx={{ minWidth: '32px' }}>
            <LightMode fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Light mode" />
        </MenuItem>

        <MenuItem
          onClick={() => handleModeSelect('dark')}
          selected={mode === 'dark'}
          sx={{ fontSize: '14px' }}
        >
          <ListItemIcon sx={{ minWidth: '32px' }}>
            <DarkMode fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Dark mode" />
        </MenuItem>
      </Menu>
    </Box>
  );
};
